import { pitRing, offsetM } from './excavation';
import { pipeLatLngs } from './model';

const segDist = (p, a, b) => {
  const dx = b[0] - a[0], dy = b[1] - a[1], L2 = dx * dx + dy * dy;
  const u = L2 ? Math.max(0, Math.min(1, ((p[0] - a[0]) * dx + (p[1] - a[1]) * dy) / L2)) : 0;
  return Math.hypot(p[0] - a[0] - u * dx, p[1] - a[1] - u * dy);
};
const inside = (p, poly) => {
  let c = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const [xi, yi] = poly[i], [xj, yj] = poly[j];
    if ((yi > p[1]) !== (yj > p[1]) && p[0] < ((xj - xi) * (p[1] - yi)) / (yj - yi) + xi) c = !c;
  }
  return c;
};
const cross = (a, b, c, d) => {
  const o = (p, q, r) => Math.sign((q[0] - p[0]) * (r[1] - p[1]) - (q[1] - p[1]) * (r[0] - p[0]));
  return o(a, b, c) !== o(a, b, d) && o(c, d, a) !== o(c, d, b);
};

// min distance (m) between a pipe polyline and a pit polygon; 0 = crossing / inside
export function pipePitDist(pipe, pit, fittings) {
  const ring = pitRing(pit) || [];
  if (ring.length < 3) return Infinity;
  const o = ring[0], poly = ring.map((q) => offsetM(o, q)), line = pipeLatLngs(pipe, fittings).map((q) => offsetM(o, q));
  if (line.length < 2) return Infinity;
  let best = Infinity;
  for (let i = 0; i < line.length - 1; i++) {
    const a = line[i], b = line[i + 1];
    if (inside(a, poly) || inside(b, poly)) return 0;
    for (let k = 0; k < poly.length; k++) {
      const c = poly[k], d = poly[(k + 1) % poly.length];
      if (cross(a, b, c, d)) return 0;
      best = Math.min(best, segDist(c, a, b), segDist(a, c, d), segDist(b, c, d));
    }
  }
  return best;
}

// ALL project pipes / cables (ignores visibility) within 1 m of the pit
export const pitClashes = (pit, project, tol = 1) => (project.pipes || [])
  .filter((p) => p.type !== 'leak')
  .map((p) => ({ pipe: p, d: pipePitDist(p, pit, project.fittings || []) }))
  .filter((x) => x.d <= tol);
